(function() {
    'use strict';

    angular.module('app.deducibles', []);
})();
